import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutFAKProfileList extends Layout {
    labelSearchFakProfile: Label;
    sourceFakProfile: DataSource;
    tableFakProfileList: Table;
}
